import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue";
import { Formatter } from "@/util/Formatter";
import Totals from "@/model/Totals";
import { onMounted, reactive, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TotalsDisplay',
    props: {
        totals: { type: Totals, required: false },
        isCancelled: { type: Boolean, required: false, default: false }
    },
    setup(__props) {
        let nullsafeTotals = reactive(new Totals());
        const props = __props;
        onMounted(() => {
            if (props.totals) {
                nullsafeTotals.assign(props.totals);
            }
        });
        watch(() => props.totals, (newValue) => {
            if (newValue) {
                nullsafeTotals.assign(newValue);
            }
        });
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, { class: "d-flex flex-wrap pa-0" }, {
                default: _withCtx(() => [
                    (_unref(nullsafeTotals).charges && _unref(nullsafeTotals).charges.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_v_container, { class: "v-col-6 text-h6 font-weight-bold text-start pb-0" }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode("Bestellsumme")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "v-col-6 text-h6 font-weight-bold text-end pb-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(Formatter).currency(_unref(nullsafeTotals).grossOrderedTotal)), 1)
                                ]),
                                _: 1
                            }),
                            (props.isCancelled)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_v_container, { class: "v-col-6 text-start py-0" }, {
                                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                                            _createTextVNode("Stornierung")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_container, { class: "v-col-6 text-end py-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(Formatter).currency(-_unref(nullsafeTotals).grossOrderedTotal)), 1)
                                        ]),
                                        _: 1
                                    })
                                ], 64))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nullsafeTotals).charges, (charge, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: 'charge-' + index
                                }, [
                                    _createVNode(_component_v_container, { class: "v-col-6 text-start py-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(charge.description), 1)
                                        ]),
                                        _: 2
                                    }, 1024),
                                    _createVNode(_component_v_container, { class: "v-col-6 text-end py-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(Formatter).currency(charge.grossAmount)), 1)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ], 64));
                            }), 128))
                        ], 64))
                        : _createCommentVNode("", true),
                    _createVNode(_component_v_container, { class: "v-col-6 text-h5 font-weight-bold text-start pb-0" }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode("Summe")
                        ])),
                        _: 1
                    }),
                    _createVNode(_component_v_container, { class: "v-col-6 text-h5 font-weight-bold text-end pb-0" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(Formatter).currency(_unref(nullsafeTotals).grossChargeableTotal)), 1)
                        ]),
                        _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(nullsafeTotals).taxes), (entry, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            _createVNode(_component_v_container, { class: "v-col-6 text-start py-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode("inkl. " + _toDisplayString(_unref(Formatter).decimalToPercent(Number(entry[0]))) + " MwSt. ", 1)
                                ]),
                                _: 2
                            }, 1024),
                            _createVNode(_component_v_container, { class: "v-col-6 text-end py-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(Formatter).currency(entry[1])), 1)
                                ]),
                                _: 2
                            }, 1024)
                        ], 64));
                    }), 128))
                ]),
                _: 1
            }));
        };
    }
});
